package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.repository.RosterRepository

class DeleteRosterUseCase(
    private val rosterRepository: RosterRepository
) {
    suspend operator fun invoke(rosterId: String): Result<Unit> {
        return rosterRepository.deleteRoster(rosterId)
    }
}